import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';
import { getFarmInvitations } from 'app/agriculture/queries/invitations/getFarmInvitations';
import { useSelectedFarm } from 'app/agriculture/hooks/useSelectedFarm/useSelectedFarm';
import { ApiEndpoint } from 'app/agriculture/queries/apiEndpoints';

export function useFarmInvitations() {
    const farm = useSelectedFarm();
    const { data } = useSuspenseQuery(
        queryOptions({
            queryKey: [ApiEndpoint.invitations, { farmId: farm.id }],
            queryFn: getFarmInvitations,
        }),
    );

    return data;
}
